import layoutHeaderAside from '@/layout'
import financial from './modules/financial/financial'
import finRep from './modules/finRep/finRep'
import finSet from './modules/finSet/finSet'
import finDetail from './modules/finDetail/finDetail'
// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: '/',
        alias: '/financial',
        name: 'index',
        meta: {
          auth: true,
          funcID: 'C00',
          PID: 'C00',
          head: true,
          title: '首页'
        },
        component: _import('financial')
      },
      {
        path: '/403',
        name: '403',
        meta:{
          title: '无权限访问'
        },
        component: _import('system/403')
      },
    ]
  },
  financial,
  finRep,
  finSet,
  finDetail
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      funcID: 'LOGIN'
    },
    component: _import('system/login')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut
  // ...errorPage
]
